import { render } from "./ShippingDetails.vue?vue&type=template&id=e7cd77a0&scoped=true"
import script from "./ShippingDetails.vue?vue&type=script&lang=js"
export * from "./ShippingDetails.vue?vue&type=script&lang=js"

import "./ShippingDetails.vue?vue&type=style&index=0&id=e7cd77a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7cd77a0"]])

export default __exports__